import React, { useEffect, useRef } from 'react';

let tvScriptLoadingPromise;

export default function TradingViewWidget() {
    const onLoadScriptRef = useRef();
    const container = useRef();
    useEffect(
        () => {
            createWidget()
            // onLoadScriptRef.current = createWidget;

            // if (!tvScriptLoadingPromise) {
            //     tvScriptLoadingPromise = new Promise((resolve) => {
            //         // const script = document.createElement('script');
            //         // script.id = 'tradingview-widget-loading-script';
            //         // script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js';
            //         // script.type = 'text/javascript';
            //         // script.onload = resolve;

            //         // document.head.appendChild(script);
            //         resolve();
            //     });
            // }

            // tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());

            function createWidget() {
                if (document.getElementById('tradingview_2e4b2')) {
                    const script = document.createElement("script");
                        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
                        script.type = "text/javascript";
                        script.async = true;
                        script.innerHTML = `
                            {
                            "symbols": [
                                [
                                "IDX:UNTR|1M"
                                ]
                            ],
                            "chartOnly": false,
                            "width": 1000,
                            "height": 500,
                            "locale": "en",
                            "colorTheme": "light",
                            "autosize": false,
                            "showVolume": false,
                            "showMA": false,
                            "hideDateRanges": false,
                            "hideMarketStatus": false,
                            "hideSymbolLogo": false,
                            "scalePosition": "right",
                            "scaleMode": "Normal",
                            "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
                            "fontSize": "10",
                            "noTimeScale": false,
                            "valuesTracking": "1",
                            "changeMode": "price-and-percent",
                            "chartType": "area",
                            "maLineColor": "#2962FF",
                            "maLineWidth": 1,
                            "maLength": 9,
                            "lineWidth": 2,
                            "lineType": 0,
                            "dateRanges": [
                                "1d|1",
                                "1m|30",
                                "3m|60",
                                "12m|1D",
                                "60m|1W",
                                "all|1M"
                            ]
                            }`;
                        container.current.appendChild(script);
                }
            }
            // return () => container.current.innerHTML = '';
        },
        []
    );

    return (
        <div className='tradingview-widget-container'>
            <div id='tradingview_2e4b2' className='d-flex justify-content-center' ref={container}></div>
            <div className="tradingview-widget-copyright">
                <a href="https://www.tradingview.com/symbols/IDX-UNTR/" rel="noopener" target="_blank"><span className="blue-text">United Tracktors</span></a> by TradingView
            </div>
        </div>
    );
}
